import { GoogleMap } from '@angular/google-maps';
import { CardModel, Image, SubCategory } from '@shared/models/card.model';
import { CardList } from '@shared/models/card-list';
import { Config } from '@core/config';
import { FiltersComponent } from '@shared/components/filters/filters.component';

export function centerMap(map: GoogleMap, card: CardModel) {
  const bounds = new google.maps.LatLngBounds().extend(card.position);
  for (const marker of card.nearbyFiches) {
    bounds.extend(marker.position);
  }

  // @ts-ignore
  if (!!map && bounds.Bb.g !== 1) {
    map.panTo(bounds.getCenter());
    map.fitBounds(bounds);
  }
}

export function getGMapIcon(card: CardList): {
  scaledSize: google.maps.Size;
  size: google.maps.Size;
  anchor: google.maps.Point;
  url: string;
} {
  let url: string;
  if (parseInt(card.category, 10) !== 1) {
    url = `${Config.markerImage}${
      card.idSubcategory !== null ? card.idSubcategory : '_' + card.category
    }.png`;
  } else {
    // tslint:disable-next-line:no-bitwise
    const circuit = FiltersComponent._translateCircuitType(card.circuitType, 1)
      ? 1
      : FiltersComponent._translateCircuitType(card.circuitType, 2)
      ? 2
      : FiltersComponent._translateCircuitType(card.circuitType, 4)
      ? 4
      : FiltersComponent._translateCircuitType(card.circuitType, 8)
      ? 8
      : FiltersComponent._translateCircuitType(card.circuitType, 16)
      ? 16
      : 32;
    url = `${Config.markerImage}circuit_${
      card.idSubcategory !== undefined ? card.idSubcategory : circuit
    }.png`;
  }

  return {
    url,
    size: new google.maps.Size(36, 50),
    scaledSize: new google.maps.Size(36, 50),
    anchor: new google.maps.Point(18, 50),
  };
}

/**
 * Get the correct image given the param.
 * When no data is founded, then we it's a placeholder that is returned.
 * @param {CardList} mc
 * @returns {string} url string.
 */
export function getActualImage(
  categ: number,
  url: string | null = null
): string {
  if (url !== null) return url;
  if (categ == 0)
    return 'assets/images/placeholders/tn_placeholder_heritage.png';
  if (categ == 1)
    return 'assets/images/placeholders/tn_placeholder_circuits.png';
  if (categ == 2)
    return 'assets/images/placeholders/tn_placeholder_services.png';
  if (categ == 3) return 'assets/images/placeholders/tn_placeholder_events.png';
  if (categ == 4) return 'assets/images/placeholders/tn_placeholder_quizz.jpg';
  return 'assets/images/placeholders/tn_placeholder_heritage.png';
}

/**
 * Use this to update image element when image doesn't exists.
 * @param {CardList} mc
 */
export function onImageError(
  categ: number,
  img: HTMLImageElement,
  subcategory?: string
): void {
  if (categ == 0) {
    img.src = 'assets/images/placeholders/tn_placeholder_heritage.png';
    return;
  }
  if (categ == 1) {
    img.src = 'assets/images/placeholders/tn_placeholder_circuits.png';
    return;
  }
  if (categ == 2) {
    if (subcategory && subcategory == '38') {
      img.src = 'assets/images/home_img_producteur.jpg';
      return;
    }
    img.src = 'assets/images/placeholders/tn_placeholder_services.png';
    return;
  }
  if (categ == 3) {
    img.src = 'assets/images/placeholders/tn_placeholder_events.png';
    return;
  }
  if (categ == 4) {
    img.src = 'assets/images/placeholders/tn_placeholder_quizz.jpg';
    return;
  }
  img.src = 'assets/images/placeholders/tn_placeholder_heritage.png';
}

/**
 * Check if current device is mobile or normal browser.
 * @returns
 */
export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

/**
 * Check any data from valdoise server that could be strange.
 * @param {any} value
 * @returns {boolean}
 */
export function checkValDoiseData(value: any): boolean {
  return value != null && value != undefined && value != '';
}

/**
 * Get max distance range from all circuits.
 * @param {CardList[]}
 * @returns {number}
 * TODO Utiliser cette fonction.
 */
export function getMaxDistanceRange(cardList: CardList[]): number {
  const maxDistance = Math.max(...cardList.map(({ distance }) => distance));
  return (
    cardList.filter(({ distance }) => distance === maxDistance)[0].distance ?? 0
  );
}

/**
 * Get min distance range from all circuits.
 * @param {CardList[]}
 * @returns {number}
 * TODO Utiliser cette fonction.
 */
export function getMinDistanceRange(cardList: CardList[]): number {
  const minDistance = Math.min(...cardList.map(({ distance }) => distance));
  return (
    cardList.filter(({ distance }) => distance === minDistance)[0].distance ?? 0
  );
}

/**
 * Get max duration range from all circuits.
 * @param {CardList[]}
 * @returns {number}
 * TODO Utiliser cette fonction.
 */
export function getMaxDurationRange(cardList: CardList[]): number {
  const maxDuration = Math.max(...cardList.map(({ duration }) => duration));
  return (
    cardList.filter(({ duration }) => duration === maxDuration)[0].duration ?? 0
  );
}

/**
 * Get min duration range from all circuits.
 * @param {CardList[]}
 * @returns {number}
 * TODO Utiliser cette fonction.
 */
export function getMinDurationRange(cardList: CardList[]): number {
  const minDuration = Math.max(...cardList.map(({ duration }) => duration));
  return (
    cardList.filter(({ duration }) => duration === minDuration)[0].duration ?? 0
  );
}

/**
 *
 */
export function determineSubCateg(card: any): string {
  if (card.category == 3) {
    return 'Agenda';
  }

  if (card.category == 4) {
    return 'Jeux';
  }

  // Circuit case.
  if (card.circuitType != null) {
    switch (card.circuitType) {
      case 1:
        return 'A pied';
      case 2:
        return 'A vélo - VTT';
      case 6:
        return 'A vélo - VTT';
      case 10:
        return 'A vélo - VTT';
      case 14:
        return 'A vélo - VTT';
      case 4:
        return 'A vélo - VTC';
      case 12:
        return 'A vélo - VTC';
      case 8:
        return 'A vélo - sur route';
      case 16:
        return 'A cheval';
      case 32:
        return 'Trail';
    }
  }

  // The others.
  switch (card.idSubcategory) {
    case 0:
      return 'Archéologie';
    case 1:
      return 'Arts et Culture';
    case 2:
      return 'Nature';
    case 3:
      return 'Architectures publiques';
    case 4:
      return 'Patrimoine agricole';
    case 5:
      return "Autour de l'eau";
    case 6:
      return 'Patrimoine religieux et commemoratif';
    case 19:
      return 'Demeures et Châteaux';
    case 18:
      return 'Patrimoine industriel et commercial';
    case 37:
      return 'Activités et Loisirs';
    case 35:
      return 'Commerces et services';
    case 15:
      return 'Restaurants';
    case 14:
      return 'Hébergement';
    case 36:
      return 'Informations touristiques';
    case 12:
      return 'agenda';
  }

  // The others.
  switch (card.subcategory?.id) {
    case 0:
      return 'Archéologie';
    case 1:
      return 'Arts et Culture';
    case 2:
      return 'Nature';
    case 3:
      return 'Architectures publiques';
    case 4:
      return 'Patrimoine agricole';
    case 5:
      return "Autour de l'eau";
    case 6:
      return 'Patrimoine religieux et commemoratif';
    case 19:
      return 'Demeures et Châteaux';
    case 18:
      return 'Patrimoine industriel et commercial';
    case 37:
      return 'Activités et Loisirs';
    case 35:
      return 'Commerces et services';
    case 15:
      return 'Restaurants';
    case 14:
      return 'Hébergement';
    case 36:
      return 'Informations touristiques';
    case 12:
      return 'agenda';
    case 38:
      return 'Producteurs locaux';
  }

  return 'inconnu';
}

export function getCategoryName(card: any): string {
  if (card.category == 0) {
    return 'Patrimoine';
  }

  if (card.category == 1) {
    return 'Circuits';
  }

  if (card.category == 2) {
    return 'Services';
  }

  if (card.category == 3) {
    return 'Agenda';
  }

  if (card.category == 4) {
    return 'Jeux';
  }

  return 'inconnu';
}
